import { supabase } from './supabase'

// Planilha de estratificacao do resultado do mes (ver migration v1.8).
// Duas formas: link externo (Drive) ou arquivo no bucket privado.

export const BUCKET = 'anexos-resultados'
export const TAMANHO_MAX = 10 * 1024 * 1024
export const EXTENSOES_ACEITAS = '.xlsx,.xls,.csv,.pdf'

// Mesma regra do CHECK resultados_anexo_url_esquema: um campo de URL
// renderizado como link e' vetor de XSS, entao `javascript:` e `data:` ficam
// barrados no front e no banco.
export function urlValida(url) {
  return /^https?:\/\//i.test((url || '').trim())
}

// O nome vai para o path do objeto: tira acento, espaco e qualquer coisa que
// atrapalhe na URL, mas preserva a extensao.
function sanitizarNome(nome) {
  const ponto = nome.lastIndexOf('.')
  const base = ponto > 0 ? nome.slice(0, ponto) : nome
  const ext = ponto > 0 ? nome.slice(ponto).toLowerCase() : ''
  const limpo = base
    .normalize('NFD').replace(/\p{Diacritic}/gu, '')
    .replace(/[^a-zA-Z0-9._-]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60) || 'planilha'
  return `${limpo}${ext}`
}

export function montarCaminho({ companyId, indicadorId, ano, mes, nomeArquivo }) {
  const mm = String(mes).padStart(2, '0')
  return `${companyId}/${indicadorId}/${ano}-${mm}/${sanitizarNome(nomeArquivo)}`
}

export function temAnexo(resultado) {
  return !!resultado?.anexo_tipo
}

export function rotuloAnexo(resultado) {
  if (!temAnexo(resultado)) return ''
  return resultado.anexo_nome || (resultado.anexo_tipo === 'link' ? 'Link' : 'Planilha')
}

// Campos gravados na linha de resultados. As colunas nao usadas voltam a NULL
// para nao violar o CHECK resultados_anexo_coerente.
export function camposAnexo(anexo) {
  if (!anexo) return { anexo_tipo: null, anexo_url: null, anexo_path: null, anexo_nome: null }
  return anexo.tipo === 'link'
    ? { anexo_tipo: 'link', anexo_url: anexo.url, anexo_path: null, anexo_nome: anexo.nome || null }
    : { anexo_tipo: 'arquivo', anexo_url: null, anexo_path: anexo.path, anexo_nome: anexo.nome || null }
}

export async function enviarArquivo({ arquivo, companyId, indicadorId, ano, mes }) {
  if (arquivo.size > TAMANHO_MAX) {
    return { error: 'Arquivo maior que 10 MB.' }
  }
  const path = montarCaminho({ companyId, indicadorId, ano, mes, nomeArquivo: arquivo.name })
  const { error } = await supabase.storage
    .from(BUCKET)
    .upload(path, arquivo, { upsert: true, contentType: arquivo.type || undefined })

  if (error) {
    // O bucket recusa tipo fora da allowlist e tamanho acima do limite; a
    // mensagem crua da API nao ajuda quem esta' lancando o resultado.
    const msg = /mime|content type/i.test(error.message)
      ? 'Formato não aceito. Use .xlsx, .xls, .csv ou .pdf.'
      : error.message
    return { error: msg }
  }
  return { path, nome: arquivo.name }
}

// Bucket privado: o acesso e' sempre por URL assinada de vida curta.
export async function abrirAnexo(resultado) {
  if (!temAnexo(resultado)) return { error: 'Sem anexo.' }

  if (resultado.anexo_tipo === 'link') {
    if (!urlValida(resultado.anexo_url)) return { error: 'Link inválido.' }
    window.open(resultado.anexo_url, '_blank', 'noopener,noreferrer')
    return {}
  }

  // A aba precisa abrir no clique; se esperar o await, o bloqueador de pop-up
  // mata. Abre vazia e depois aponta para a URL assinada.
  const aba = window.open('', '_blank', 'noopener,noreferrer')
  const { data, error } = await supabase.storage
    .from(BUCKET)
    .createSignedUrl(resultado.anexo_path, 60)

  if (error || !data?.signedUrl) {
    aba?.close()
    return { error: 'Não foi possível abrir a planilha.' }
  }
  if (aba) aba.location = data.signedUrl
  else window.location.assign(data.signedUrl)
  return {}
}

// "Repetir do mes anterior" faz meses diferentes apontarem para o mesmo objeto.
// Remover um deles nao pode apagar o arquivo enquanto outro ainda o referencia.
export async function removerArquivoSeOrfao(path, { exceto } = {}) {
  if (!path) return
  let q = supabase.from('resultados').select('id').eq('anexo_path', path)
  if (exceto) q = q.neq('id', exceto)
  const { data, error } = await q.limit(1)
  if (error) return
  if (!data || data.length === 0) {
    await supabase.storage.from(BUCKET).remove([path])
  }
}
